import { useEffect, useState } from 'react'

let EditCellCheckbox = ({ checked: initialChecked, onUpdate }) => {
  const [checked, setChecked] = useState(initialChecked || false)
  useEffect(() => {
    setChecked(initialChecked || false)
  }, [initialChecked])

  return (
    <input
      type="checkbox"
      className="mt-1"
      checked={checked}
      onChange={e => {
        let newChecked = e.target.checked
        onUpdate(newChecked)
        setChecked(newChecked)
      }}
    />
  )
}

export default EditCellCheckbox
